import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Alert
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { required, maxLength } from '@src/validation';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';

const fieldValidator = {
  phase_no: [],
  address_no: [],
  street: [required, value => maxLength(value, 255)],
  unit_no: [],
  city: [required, value => maxLength(value, 255)],
  state: [required, value => maxLength(value, 64)],
  zip_code: [required, value => maxLength(value, 32)]
};
class UnitsModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};
    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value:
          props.entity.id !== undefined
            ? props.entity[key]
            : key === 'phase_no' && props.totalPhase !== null
            ? 1
            : '',
        visited: false,
        error: false
      };
    });

    this.state = { ...fields };
  }

  updateForm = (event, name) => {
    const inputData = {
      value: event.target.value,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] = formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    this.setState({ ...formData });

    if (isValid) {
      if (
        this.props.entity !== undefined &&
        this.props.entity.id !== undefined
      ) {
        this.props.onSubmit(postData, null);
      } else {
        this.props.onSubmit(postData, () => {
          const fields = {};
          Object.keys(fieldValidator).forEach(key => {
            fields[key] = {
              value:
                key === 'phase_no' && this.props.totalPhase !== null ? 1 : '',
              visited: false,
              error: false
            };
          });
          this.setState({ ...fields });
        });
      }
    }
    return false;
  };

  render = () => {
    const options = [];
    for (let i = 1; i <= this.props.totalPhase; i++) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }

    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {this.props.entity.id !== undefined ? 'Edit Unit' : 'Add a Unit'}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            <ModalBody className={'p-4'}>
              {this.props.errorUnit && (
                <Alert color={'danger'}>{this.props.errorUnit}</Alert>
              )}
              <Row>
                <Col xs={6}>
                  <label className="font-weight-bold">Phase #</label>
                  <select
                    className={'form-control'}
                    value={this.state.phase_no.value}
                    onChange={event => this.updateForm(event, 'phase_no')}
                    disabled={this.props.totalPhase === null}
                  >
                    {options}
                  </select>
                </Col>
                <Col xs={12}>
                  <hr />
                </Col>
                <Col xs={6}>
                  <LabelInput
                    name={'Address #'}
                    type={'text'}
                    {...this.state.address_no}
                    onChange={event => this.updateForm(event, 'address_no')}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabelInput
                    name={'Street Address'}
                    type={'text'}
                    required={true}
                    {...this.state.street}
                    onChange={event => this.updateForm(event, 'street')}
                  />
                </Col>
                <Col>
                  <LabelInput
                    name={'Unit #'}
                    type={'text'}
                    {...this.state.unit_no}
                    onChange={event => this.updateForm(event, 'unit_no')}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabelInput
                    name={'City'}
                    type={'text'}
                    required={true}
                    {...this.state.city}
                    onChange={event => this.updateForm(event, 'city')}
                  />
                </Col>
                <Col>
                  <LabelInput
                    name={'State'}
                    type={'text'}
                    required={true}
                    {...this.state.state}
                    onChange={event => this.updateForm(event, 'state')}
                  />
                </Col>
                <Col>
                  <LabelInput
                    name={'Zip Code'}
                    type={'text'}
                    required={true}
                    {...this.state.zip_code}
                    onChange={event => this.updateForm(event, 'zip_code')}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Save
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default UnitsModal;
